import React from 'react';
import Icon from '../../../components/AppIcon';

const AdvancedMetrics = ({ metrics }) => {
  const MetricCard = ({ icon, label, value, change, color }) => (
    <div className="bg-card border border-border rounded-lg p-4 md:p-5">
      <div className="flex items-start justify-between mb-3">
        <div className={`flex items-center justify-center w-10 h-10 bg-${color}/10 rounded-md`}>
          <Icon name={icon} size={20} color={`var(--color-${color})`} />
        </div>
        {change !== null && (
          <div className={`flex items-center gap-1 ${change >= 0 ? 'text-success' : 'text-error'}`}>
            <Icon 
              name={change >= 0 ? 'TrendingUp' : 'TrendingDown'} 
              size={14} 
              color="currentColor" 
            />
            <span className="text-xs font-medium">
              {Math.abs(change)?.toFixed(1)}
            </span>
          </div>
        )}
      </div>
      <p className="text-2xl md:text-3xl font-heading font-semibold text-foreground mb-1">
        {value}
      </p>
      <p className="text-sm text-muted-foreground">{label}</p>
    </div>
  );

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2">
        <Icon name="BarChart3" size={20} color="var(--color-primary)" />
        <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground">
          Advanced Analytics
        </h3>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <MetricCard
          icon="TrendingUp"
          label="Satisfaction Trend"
          value={metrics?.satisfactionTrend?.toFixed(1)}
          change={metrics?.satisfactionChange}
          color="success"
        />
        <MetricCard
          icon="Target"
          label="Success Rate"
          value={`${metrics?.encounterSuccessRate}%`}
          change={metrics?.successRateChange}
          color="primary"
        />
        <MetricCard
          icon="Sparkles"
          label="Predicted Compatibility"
          value={`${metrics?.predictedCompatibility}%`}
          change={metrics?.compatibilityChange}
          color="accent"
        />
        <MetricCard
          icon="Heart"
          label="Relationship Health"
          value={`${metrics?.relationshipHealth}%`}
          change={metrics?.healthChange}
          color="warning"
        />
      </div>

      <div className="bg-gradient-to-br from-primary/5 to-accent/5 border border-primary/10 rounded-lg p-4 md:p-6">
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 rounded-md bg-primary/10 flex items-center justify-center flex-shrink-0">
            <Icon name="Lightbulb" size={20} color="var(--color-primary)" />
          </div>
          <div className="flex-1">
            <h4 className="text-base md:text-lg font-heading font-semibold text-foreground mb-2">
              Predictive Insights
            </h4>
            <p className="text-sm text-muted-foreground leading-relaxed">
              Based on current trends, your relationship is projected to maintain strong compatibility over the next 30 days. 
              The AI forecasts a {metrics?.predictedCompatibility}% compatibility score with continued positive momentum in 
              emotional connection and communication quality. Focus on maintaining consistent intimacy patterns and leveraging 
              optimal timing windows for maximum satisfaction.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdvancedMetrics;